import lazyLoading from './lazyLoading'

export default {
  name: 'Classes',
  path: '/classes',
  meta: {
    auth: true,
    icon: 'fa-graduation-cap',
    link: 'classes/index.vue'
  },
  component: lazyLoading('classes', true)
  // children : []
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/classes.js